import { TextField } from "@material-ui/core";

export default function RuleTwo({value, onChange}) {
    return (
        <>
            <p>D + X</p>
            <TextField
                fullWidth
                InputLabelProps={{ shrink: true }}
                label="Campo"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                autoComplete="off"
                variant="outlined"
            />
        </>
    )
}